// Header/routerConfig.js

export const LANDING_ROUTES = [
  'Main', 
  'PaymentService', 
  'UserPaymentCheck', 
  'ProductPay'
];

export const STORYBOARD_ROUTES = [
  'StoryBoardToCEdit', 
  'WriteStoryBoard', 
  'StoryBoardSetting', 
  'StoryBoardTranslateSet',
  'ReportCompare'
];

export const BASIC_MENU_ROUTES = [
  'BasicSettings', 
  'Publishing', 
  'TeamSettings', 
  'ThemeSettings'
];

export const INDICATOR_ROUTES = [
  'GetGriRecommendations', 
  'GetSasbRecommendations', 
  'GetTcfdRecommendations', 
  'SelectGriIndicators', 
  'SelectSasbIndicators', 
  'SelectTcfdIndicators', 
  'EditDCToC'];

export const REPORT_WRITE_ROUTES = [
  'Gri100_2021',
  'Gri2',
  'Gri3',
  'Gri200',
  'Gri300',
  'Gri400',
  'WriteTcfd',
  'WriteSasb',
  'WriteDataCenters'];

export const CHECK_REPORT_ROUTES = [
  'CheckReport',
  'ApplyAssurance',
  'CoVerification',
  'GetAssuranceReport'
];
export const TRANSLATE_ROUTES = [
  'BasicTranslateSet',
  'ESasb',
  'ETcfd',
  'EDataCenter',
  'EToC',
  'DataCenterTranslateSet',
  'GriTranslateSet',
  'SasbTranslateSet',
  'TcfdTranslateSet',
  'EGri2',
  'EGri3',
  'EGri100',
  'EGri200',
  'EGri300',
  'EGri400',
  'StoryBoardTranslateSet',
  'ESbToC',
  'ESbMainComponent',
  'EStoryBoard',
  'StoryBoardTranslateSet'
];
